import http from "../js/axios";
class StatisticsService {
  getDashboardStatistics() {
    return http.post("/recipient_registration/dashboard_statistics", {
      dml_indicator: "DASHBOARD",
    });
  }
}
export default new StatisticsService();
